<template>
  <div class="index">
    <div class="top">
      <div class="top-item" v-for="(item,index) in topData" :key="index">
        <div class="item-lable">{{item.lable}}</div>
        <div class="item-value">{{item.value}}</div>
      </div>
    </div>
    <div class="content">
      <div class="content-text">营收概况</div>
      <div class="top">
        <div class="top-item" v-for="(item,index) in contentData" :key="index">
          <div class="item-lable">{{item.lable}}</div>
          <div class="item-value">
            <i class="iconfont iconxiajiang re"></i>
            <i class="iconfont iconshangsheng ge"></i>
            {{item.value}}
          </div>
          <div class="item-value">
            <i class="iconfont iconxiajiang re"></i>
            <i class="iconfont iconshangsheng ge"></i>
            {{item.value1}}
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="dashboard-show-data" id="myChart"></div>
    </div>
    <div class="index-bottom">
      <div class="item">
        <div class="item-title">30天新增视频</div>
        <div class="item-num">3232</div>
        <div class="item-bottom">
          <div class="left">总计：2345</div>
          <div class="rught">
            <i class="iconfont iconxiajiang re"></i>
            <i class="iconfont iconshangsheng ge"></i>
            11.25%
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">30天新增试题</div>
        <div class="item-num">3232</div>
        <div class="item-bottom">
          <div class="left">总计：2345</div>
          <div class="rught">
            <i class="iconfont iconxiajiang re"></i>
            <i class="iconfont iconshangsheng ge"></i>
            11.25%
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">30天新增商品</div>
        <div class="item-num">3232</div>
        <div class="item-bottom">
          <div class="left">总计：2345</div>
          <div class="rught">
            <i class="iconfont iconxiajiang re"></i>
            <i class="iconfont iconshangsheng ge"></i>
            11.25%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/legend");
require("echarts/lib/component/title");
export default {
  data: function() {
    return {
      contentData: [
        {
          lable: "本年度",
          value1: "85",
          value: "85"
        },
        {
          lable: "180天",
          value1: "85",
          value: "85"
        },
        {
          lable: "90天",
          value1: "85",
          value: "85"
        },
        {
          lable: "30天",
          value1: "85",
          value: "85"
        },
        {
          lable: "昨日",
          value1: "85",
          value: "85"
        }
      ],
      topData: [
        {
          lable: "机构",
          value: "85"
        },
        {
          lable: "学员",
          value: "1122"
        },
        {
          lable: "90天新学员",
          value: "123"
        },
        {
          lable: "30天新学员",
          value: "123"
        },
        {
          lable: "昨日新学员",
          value: "123"
        }
      ],
      timeData: [
        "2019-09-03",
        "2019-09-04",
        "2019-09-05",
        "2019-09-06",
        "2019-09-07",
        "2019-09-08"
      ],
      datas1: [10, 20, 30, 40, 100, 500],
      datas2: [30, 10, 50, 70, 130, 400]
    };
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      let myChart = echarts.init(document.getElementById("myChart"));
      myChart.setOption(
        {
          title: {},
          tooltip: {},
          legend: {
            x: "center",
            y: "top",
            data: ["营收金额", "订单数量"]
          },
          calculable: true,
          xAxis: {
            data: this.timeData,
            offset: 10
          },
          yAxis: [
            {
              type: "value",
              scale: true,
              name: "营收金额",
              max: 1200,
              min: 0,
              boundaryGap: [0.2, 0.2]
            },
            {
              type: "value",
              scale: true,
              name: "订单数量",
              max: 120,
              min: 0,
              boundaryGap: [0.2, 0.2]
            }
          ],
          series: [
            {
              name: "营收金额",
              smooth: true,
              type: "line",
              symbol: "circle",
              data: this.datas1,
              symbolSize: 8, // 拐点圆的大小
              itemStyle: {
                normal: {
                  color: "rgb(36,210,181)", // 折线条的颜色
                  borderColor: "rgb(36,210,181)" // 拐点边框颜色
                }
              }
            },
            {
              symbol: "circle",
              smooth: true,
              name: "订单数量",
              type: "line",
              data: this.datas2,
              symbolSize: 8, // 拐点圆的大小

              itemStyle: {
                normal: {
                  color: "rgb(77,148,255)", // 折线条的颜色
                  borderColor: "rgb(77,148,255)" // 拐点边框颜色
                }
              }
            }
          ]
        },
        true
      );
    }
  }
};
</script>
<style lang="less" scoped>
.index-bottom {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .item {
    padding: 10px;
    width: 30%;
    background: #fff;
    .item-title {
      font-size: 14px;
      color: #333;
      line-height: 30px;
    }
    .item-num {
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 18px;
      line-height: 40px;
    }
    .item-bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .left {
        font-size: 12px;
        line-height: 30px;
        color: #999;
      }
      .right {
        font-size: 12px;
        color: #999;
        line-height: 30px;
      }
    }
  }
}
.index {
  width: 100%;
  background: rgb(246, 249, 250);
}
.re {
  color: rgb(250, 98, 107);
}
.ge {
  color: rgb(36, 210, 181);
}
.content {
  background: #fff;
  margin-top: 20px;
  .content-text {
    padding: 10px;
    font-size: 14px;
    color: #333;
    border: 0px !important;
  }
}

.top {
  width: 100%;
  display: flex;
  background: #fff;
  padding: 10px 0px;
  .top-item {
    width: 20%;
    margin-left: 10px;
    .item-lable {
      line-height: 30px;
      white-space: nowrap;
      font-size: 12px;
      color: rgb(162, 170, 188);
    }
    .item-value {
      white-space: nowrap;
      font-size: 18px;
      color: rgb(69, 90, 100);
      line-height: 30px;
    }
  }
}
.dashboard-show-data {
  height: 470px;
  border: solid 2px rgb(246, 246, 246);
  background: #fff;
  margin-top: 20px;
  padding: 10px 10px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/index.vue